import {
    Card,
    List,
    ListItem,
    ListItemPrefix,
} from "@material-tailwind/react";
import {
    UserCircleIcon,
    PowerIcon,
    HomeIcon,
    EnvelopeIcon,
    WalletIcon,
    HeartIcon,
} from "@heroicons/react/24/solid";
import Link from "next/link";
import { useDispatch } from "react-redux";
import { useContext } from "react";
import { useRouter } from "next/navigation";
import myContext from "@/context/myContext";
import { useLogoutMutation } from "@/redux/slices/authSlice";
import apiSlice from "@/redux/slices/apiSlice";
import { MdHome } from "react-icons/md";
import { usePathname } from "next/navigation"; // Add this
import { LogOut } from "lucide-react";

export default function SideBar() {
    const dispatch = useDispatch();
    const router = useRouter();
    const { updateAuthState } = useContext(myContext);
    const [logout] = useLogoutMutation();
    const pathname = usePathname(); // Get current pathname

    const handleLogout = async () => {
        await logout();
        updateAuthState();
        dispatch(apiSlice.util.resetApiState());
        router.push("/");
    };
     const isActive = (path) => pathname === path;


    return (
        <div className="h-full w-full max-w-[16rem] p-4 border-r border-r-gray-300 bg-white overflow-y-auto">
            <div className="mb-6 p-2 border-b border-gray-200">
                <h2 className="text-lg font-semibold text-black">Manage your Account</h2>
            </div>

            <List>
                <div className="mb-4">
                    <Link href="/user/home">
                         <ListItem className={isActive("/user/home") ? "bg-gray-200 text-gray-900 font-semibold" : ""}>
                            Basic Profile
                        </ListItem>
                    </Link>
                    <Link href="/user/my-property">
                       <ListItem className={isActive("/user/rent-property") ? "bg-gray-200 text-gray-900 font-semibold" : ""}>
                            Your Properties
                        </ListItem>
                    </Link>
                   
                </div>

                <div className="mt-2 border-t border-gray-200 pt-2">
                    <button onClick={handleLogout} className="w-full text-left">
                        <ListItem>
                            <ListItemPrefix>
                                <LogOut className="h-5 w-5 text-gray-600" />
                            </ListItemPrefix>
                            Log Out
                        </ListItem>
                    </button>
                </div>
            </List>
        </div>
    );
}
